import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/recyclingMaterials/importer/recyclingMaterialsImporterSelectors';
import RecyclingMaterialsService from 'src/modules/recyclingMaterials/recyclingMaterialsService';
import fields from 'src/modules/recyclingMaterials/importer/recyclingMaterialsImporterFields';
import { i18n } from 'src/i18n';

const recyclingMaterialsImporterActions = importerActions(
  'RECYCLINGMATERIALS_IMPORTER',
  selectors,
  RecyclingMaterialsService.import,
  fields,
  i18n('entities.recyclingMaterials.importer.fileName'),
);

export default recyclingMaterialsImporterActions;